import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { Cargo } from 'src/app/core/interfaces/cargo';
import { ParamsCargoList } from 'src/app/core/interfaces/paramsCargoList';
import { DateFormatPipe } from 'src/app/core/pipe/dateFormat.pipe';
import { Utils } from 'src/app/core/resources/utils';
import { CargoService } from 'src/app/core/services/cargo.service';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ModalLicensePlateComponent } from '../modal-license-plate/modal-license-plate.component';
import { ModalEnum } from 'src/app/core/enums/modal.enum';
import { DateManager } from 'src/app/core/managers/date.manager';

@Component({
  selector: 'app-summary-anomaly-item-cargo-tracking',
  templateUrl: './summary-anomaly-item-cargo-tracking.component.html',
  styleUrls: ['./summary-anomaly-item-cargo-tracking.component.scss'],
  providers: [CargoService, DateFormatPipe]
})
export class SummaryAnomalyItemCargoTrackingComponent implements OnInit {

  @Input() anomaly: string;
  @Input() amount: string;
  @Input() state: string;
  @Input() color: any;
  @Input() companyId: string;
  @Input() exclusive: boolean;
  @Input() dateLoad: string;
  @Input() endDate: string;
  public cargos: Cargo[] = [];

  constructor(
    private cargoService: CargoService,
    public utils: Utils,
    public dialog: MatDialog,
  ) {

  }

  ngOnInit() {
    this.dateLoad = DateManager.dateToString(DateManager.substract(new Date(), 20, 'days'), 'YYYY-MM-DD ZZ');
    this.endDate = DateManager.dateToString(new Date(), 'YYYY-MM-DD ZZ');
    this.getTotalCargo();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes.companyId && changes.companyId.currentValue) {
      this.getTotalCargo();
    }
  }

  private getTotalCargo(): void {
    const params: ParamsCargoList = {};
    if (!this.utils.isEmpty(this.state)) {
      params.state = this.state;
    }
    if (!this.utils.isEmpty(this.anomaly)) {
      params.anomalies = [this.anomaly];
    }
    if (!this.utils.isEmpty(this.anomaly)) {
      params.news = this.anomaly;
    }
    if (!this.utils.isEmpty(this.companyId) && this.companyId != '-1') {
      params.nit = this.companyId;
    }
    if (!this.utils.isEmpty(this.exclusive)) {
      params.exclusive = this.exclusive;
    }
    if (!this.utils.isEmpty(this.dateLoad)) {
      params.dateLoad = this.dateLoad;
    }
    if (!this.utils.isEmpty(this.endDate)) {
      params.endDate = this.endDate;
    }
    this.cargoService.cargoList(params).subscribe(
      (response) => {
        if (response) {
          this.cargos = response.results;
        } else {
          this.cargos = [];
        }
      },
      (error) => {

      }
    );
  }

  public get backgroundStyle() {
    return { 'background-color': this.color };
  }

  public ShowVehicles() {
    if (!this.anomaly) {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.data = {
        cargos: this.cargos,
        title: "Vehiculos en ruta"
      };
      dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
      dialogConfig.width = ModalEnum.MEDIUM_WIDTH;
      dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
      dialogConfig.autoFocus = false;
      this.dialog.open(ModalLicensePlateComponent, dialogConfig);
    }
  }
}
